import { useState, useEffect } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';

const FullscreenButton = ({ videoRef, className = '', isVisible = true }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreen = () => {
    if (!videoRef.current) return;

    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      // Enter fullscreen
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement || !!document.webkitFullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <button
      onClick={handleFullscreen}
      className={`group absolute bottom-4 right-4 z-[100] rounded-lg border border-white/20 bg-black/50 p-2 backdrop-blur-sm transition-all duration-300 hover:bg-black/70 md:bottom-8 md:right-8 w-fit h-fit ${className}`}
      aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
      style={{ pointerEvents: 'auto' }}
    >
      {isFullscreen ? (
        <Minimize2 className="size-5 text-white transition-transform group-hover:scale-110 md:size-6" />
      ) : (
        <Maximize2 className="size-5 text-white transition-transform group-hover:scale-110 md:size-6" />
      )}
    </button>
  );
};

export default FullscreenButton;